import { useState, MutableRefObject } from 'react';
// 常量
import { FormModalActionType } from '../../../FormModal/interface';
import { SuperFormItemProps } from '../../../SuperForm/interface';

export function useGetFormItems(
  actionRef: MutableRefObject<FormModalActionType>,
  draftsData?: any,
): SuperFormItemProps[] {
  const [required, setRequired] = useState<boolean>(true);
  const baseFormItems: SuperFormItemProps[] = [];
  const handleChange = (checked: boolean) => {
    setRequired(!checked);
    if (checked && draftsData) {
      actionRef.current?.form?.setFieldsValue({
        draftsName: draftsData.draftsName,
      });
    } else {
      actionRef.current?.form?.setFieldsValue({ draftsName: '' });
    }
  };
  if (draftsData) {
    baseFormItems.push({
      formItemType: 'Switch',
      label: '是否覆盖当前草稿箱',
      initialValue: false,
      name: 'isCover',
      switchProps: {
        checkedChildren: '是',
        unCheckedChildren: '否',
        onChange: handleChange,
      },
    });
  }
  return [
    ...baseFormItems,
    {
      formItemType: 'Input',
      label: '草稿箱名称',
      name: 'draftsName',
      inputProps: {
        placeholder: '请输入草稿箱名称',
        maxLength: 50,
      },
      rules: [
        {
          required: required,
          message: '请输入草稿箱名称',
        },
      ],
    },
  ];
}
